<template>
    <div>
        <header-portrate />
        <div class="m-2 pa-2">
            <bread-crumbs :items="items" />
            <tabs-comp :tabs="tabs" />
            <div class="viewCell">
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="البحث"
                    hide-details
                ></v-text-field>
                <div class="text-left p-2">
                    <b-button
                        v-b-toggle.addTicket
                        class="btn-sm btn "
                        style="margin-top:11px;width:150px;background:transparent;border:none"
                        id="multiply-button" 
                        @click="addCustomer({id: 0})"
                    >
                    <div style="width:150px;" :class="`multiply-button-content-`+lang.lalgin">اضافة تذكرة</div>
                    
                    </b-button>
                    
                </div>
                
            </div>
        </div>
        <div  class="m-2 pa-2">
            <v-row class="d-none d-md-flex">
                <v-col cols="12" style="direction: rtl;">
                    <v-data-table
                        :headers="headers"
                        :items="tableData"
                        :search="search"
                        :items-per-page="15"
                        :page.sync="page"
                        width="100%"
                        id="MainTable"
                        hide-default-footer
                        @page-count="pageCount = $event"
                        fixed-header
                        class="table-sm"
                    >
                        <template v-slot:item="row">
                        <tr>
                            <!-- <td style="border-bottom:1px solid #fff !important;text-align:center;direction:rtl;background:#000">
                                <b-button class="btn btn-sm" style="background:#000;color:#fff;border:none" @click="edit(row.item,3)" v-b-toggle.viewCRMCase>تعديل &nbsp;	&nbsp;	<i :class="`fas fa-caret-`+lang.lalgin"></i></b-button>
                            </td> -->
                            <td :style="`text-align:center;background:#000;color:#FFF !important;height:30px !important;width:75px !important;cursor:pointer;border-bottom:1px solid #fff !important;`" v-b-toggle.billAddCustomer @click="addCustomer(row.item)">
                                <div class="viewCell">عرض <i class="fas fa-caret-left"></i></div>
                            </td>
                            <td style="text-align:center;">{{ row.item.clientName }}</td>
                            <td style="text-align:center;" nowrap>{{ row.item.clientCRT }}</td>
                            <td style="text-align:center;direction:ltr" nowrap>{{ row.item.clientVAT }}</td>
                            <td style="text-align:center;direction:ltr" nowrap>{{ row.item.clientDomain }}</td>
                            <td style="text-align:center;direction:ltr" nowrap>{{ row.item.LastInvDate.substring(0,10) }}</td>
                            <td style="text-align:center;" nowrap>{{ row.item.lastMessageOpened }}</td>
                            <td style="text-align:center;direction:ltr" nowrap>{{ row.item.expireDate.substring(0,10) }}</td>
                            <td style="text-align:center;" nowrap>{{ row.item.anyDesk }}</td>
                            <td :style="`text-align:center;background:${row.item._statusColor};color:#FFF !important;width:120px`" nowrap>{{ row.item._status }}</td>
                        </tr>
                        </template>
                    </v-data-table>
                    
                    </v-col>
                    <v-col cols="12" style="margin-bottom:25px;margin-top:-15px;">

                    <v-container>
                        <div class="text-center pt-2">
                        <v-pagination
                            v-model="page"
                            value="10"
                            :length="pageCount"
                        ></v-pagination>
                        </div>
                    </v-container>
                </v-col>
            </v-row>
        </div>
        <addSupport ref="addSupport" />
    </div>
</template>

<script>

import { mapActions,mapGetters} from 'vuex'
import HeaderPortrate from '@/components/Header-Portrate.vue';
import BreadCrumbs from '@/components/breadCrumbs.vue'
import TabsComp from '@/components/tabsComp.vue'
import addSupport from '@/components/addSupport.vue'

export default{
    name: 'CustomerSupport',
    components:{HeaderPortrate,BreadCrumbs,TabsComp,addSupport},
    data() {
        return {
            search: '',
            page: 1,
            pageCount: 15
        }
    },
    computed:{
        ...mapGetters({
            supportState: `customerSupport/supportState`
        }),
        lang: function() {
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                return this.$store.state.lang.en;
                }else{
                return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        items: function(){
            return {
                text: 'قائمة العملاء',
                disabled: true,
                href: '/',
            }
        },
        tabs: function(){ 
            return [
                {
                    index:6,name:this.lang.projects,href:'/customers',class:'mytab3',status:1
                },
                {
                    index:0,name:this.lang.customers,href:'/clientList',class:'mytab3',status:1
                },
                {
                    index:5,name:this.lang.invoices,href:'/invoicelist',class:'mytab3',status:1
                },
                {
                    index:5,name: 'مراجعة العملاء',href:'/billClients',class:'mytab3',status:1
                },
                {
                    index:1,name:this.lang.new_quotations,href:'/quotations/n/1',class:'mytab3',status:1
                },
                {
                    index:2,name:this.lang.invoiced_quots,href:'/quotations/i/2',class:'mytab3',status:2
                },
                {
                    index:3,name:this.lang.canceled_quots,href:'/quotations/c/3',class:'mytab3',status:3
                },
                {
                    index:3,name:"الدعم الفني",href:'/customer-suppport',class:'mytab',status:3
                },
                {
                    index:3,name:"التجديد",href:'',class:'mytab3',status:3
                },
            ]
        },
        headers: function(){
            return [
                {
                    text: 'الاجراء',
                    align: 'center',
                    filterable: false,
                    sortable:false,
                    value: 'center'
                },
                {
                    text: 'العميل',
                    align: 'center',
                    sortable:false,
                    value: 'clientName',
                },
                {
                    text: 'رقم الاتصال',
                    align: 'center',
                    sortable:false,
                    value: 'clientName',
                },
                {
                    text: 'عنوان التذكرة',
                    align: 'center',
                    sortable:false,
                    value: 'clientName',
                },
                {
                    text: 'تاريخ الاضافة',
                    align: 'center',
                    sortable:false,
                    value: 'clientName',
                },
                {
                    text: 'المسؤول',
                    align: 'center',
                    sortable:false,
                    value: 'clientName',
                },
                {
                    text: 'الموعد النهائي',
                    align: 'center',
                    sortable:false,
                    value: 'clientName',
                },
                {
                    text: 'آخر رد بواسطة',
                    align: 'center',
                    sortable:false,
                    value: 'clientName',
                },
                {
                    text: 'الحالة',
                    align: 'center',
                    sortable:false,
                    value: 'clientName',
                },
            ]
        },
        tableData: function(){
            let t=[];

            return t;
        }
    },
    methods:{
        ...mapActions({
            getClients: `customerSupport/getClientList`
        }),
    },
    async created(){
        await this.getClients();
    }
}
</script>
<style>
.viewCell{
    display:flex;
    flex-direction: row;
    justify-content: space-between;
    justify-items: center;
    align-items: center;
}
</style>